import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/** Shown while the Cognito session is being read on page load (instead of a 404 flash). */
const AuthLoading = () => (
    <Box role="status" aria-label="Loading" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
    </Box>
);

export default AuthLoading;
